<template>
  <div v-show="sizes.length > 1" :class="bemBlock" :data-is-locked="isLocked">
    <span
      v-for="size in sizes"
      :key="size.id"
      :class="[
        bemElement('container', {
          'no-sale': isMarketWithoutSale,
          disabled: isDisabled(size),
        }),
      ]"
    >
      <input
        :id="prefix + size.id"
        :type="multipleSelection ? 'checkbox' : 'radio'"
        :class="bemElement('size-input')"
        name="product_size"
        :value="size.value"
        :data-attr-url="size.url"
        :checked="isChecked(size)"
        :disabled="isDisabled(size) && !isStockAlertEnabled"
        @change="handleSizeChange($event, size)"
      />
      <div :class="['size-box', { 'is-strike': isDisabled(size) }]">
        <label
          :class="
            bemElement('size-label', {
              selected: isChecked(size),
            })
          "
          :for="prefix + size.id"
        >
          <s v-if="isDisabled(size)">
            {{ sizeLabel(size) }}
          </s>
          <template v-else>
            {{ sizeLabel(size) }}
          </template>
          <div class="strike" />
        </label>
      </div>
      <button
        v-if="isDisabled(size) && isStockAlertEnabled"
        :class="['btn', bemElement('btn-notify-me')]"
        @click.prevent="handleSizeChange($event, size)"
      >
        <span>{{ $msg('button.stockalert', 'product') }}</span>
        <div :class="bemElement('icon-notify-me')" />
      </button>
    </span>
  </div>
</template>

<script>
import EventBusConfig from '../config/eventBusConfig';
import bemClassesMixin from '../mixins/bemClassesMixin';
import productPropSizesMixin from '../mixins/productPropSizesMixin';

const { FRONT_CONFIG } = window;

export default {
  name: 'TheProductDetailsSizeSelector',

  mixins: [bemClassesMixin, productPropSizesMixin],

  props: {
    keepEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    multipleSelection: {
      type: Boolean,
      required: false,
      default: false,
    },
    prefix: {
      type: String,
      required: false,
      default: '',
    },
    showSizeConversion: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      isMarketWithoutSale: FRONT_CONFIG?.isMarketWithoutSale,
      isLocked: false,
      selectedSizes: [],
    };
  },

  computed: {
    productId() {
      return this.product?.id;
    },
    isStockAlertEnabled() {
      return this.product?.bylStockAlertEnabled;
    },
  },

  watch: {
    productId() {
      this.handleUniqueSizeProducts();
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.handleUniqueSizeProducts();
    });
    this.$eventBus?.$on(
      EventBusConfig.commands.TheProductDetails.lookSizeSelector,
      this.lockSizeSelector
    );
    this.$eventBus?.$on(
      EventBusConfig.commands.TheProductDetails.resetSizeSelector,
      this.resetSelector
    );
  },
  beforeDestroy() {
    this.$eventBus?.$off(
      EventBusConfig.commands.TheProductDetails.lookSizeSelector,
      this.lockSizeSelector
    );
    this.$eventBus?.$off(
      EventBusConfig.commands.TheProductDetails.resetSizeSelector,
      this.resetSelector
    );
  },

  methods: {
    sizeLabel(size) {
      return (this.showSizeConversion && size.displayText) || size.displayValue;
    },
    handleUniqueSizeProducts() {
      if (this.hasUniqueSize()) {
        this.selectedSizes = [this.getUniqueSize()];
        this.emitSizeChangeEvents(this.selectedSizes[0]);
      }
    },
    handleSizeChange(event, size) {
      if (this.selectedSizes.includes(size)) {
        this.selectedSizes = this.selectedSizes.filter(
          (selectedSize) => selectedSize !== size
        );
      } else {
        if (this.multipleSelection) {
          this.selectedSizes.push(size);
        } else {
          this.selectedSizes = [size];
        }
        if (!(this.isDisabled(size) && !this.isStockAlertEnabled)) {
          this.emitSizeChangeEvents(size);
        }
      }
    },
    emitSizeChangeEvents(size) {
      this.$emit('size:change', size, this.selectedSizes);
    },
    isChecked(size) {
      return (
        this.selectedSizes.findIndex(
          (selectedSize) => selectedSize.value === size.value
        ) !== -1
      );
    },
    isDisabled(size) {
      return !this.keepEnabled && !this.isMarketWithoutSale && !size.selectable;
    },
    lockSizeSelector() {
      this.isLocked = true;
    },
    uncheckInput() {
      this.selectedSizes = [];
    },
    resetSelector() {
      this.isLocked = false;
      if (!this.hasUniqueSize()) {
        this.selectedSizes = [];
      }
    },
  },
};
</script>
